import React, { useEffect } from 'react'
import { Linking } from 'react-native'
import { AnnulationCondition } from '../../AnnulationCondition/AnnulationCondition'
import { BookingStatus } from '../../App/Components/BookingStatus/BookingStatus'
import { Appointment } from '../../Appointment/Appointment'
import { BookAppointment } from '../../BookAppointment/BookAppointment'
import { ExtraActivity } from '../../ExtraActivity'
import { BookLastMinute, LastMinutesOverview } from '../../LastMinutes'
import { Menu } from '../../Menu'
import { MoveAppointment } from '../../MoveAppointment/MoveAppointment'
import { PaymentFallback } from '../../PaymentFallback/PaymentFallback/PaymentFallback'
import { Route, Switch, useParams } from '../../Router'
import { SelectLocation } from '../../SelectLocation/SelectLocation'
import { SelectPerson } from '../../SelectPerson/SelectPerson'
import { SurveyBootstrap } from '../../Survey'
import { MainBootstrap } from '../Bootstrap/MainBootstrap'
import { BookWaitingList } from '../../BookWaitingList/BookWaitingList'
import { OptInForm } from '../../OptIn'
import { getCustomerSession } from '../../cookies/session.cookies'
import { EditPerson } from '../../MoveAppointment/components/EditPerson/EditPerson'
import AppointmentMovedSuccess from '../../MoveAppointment/components/AppointmentMovedSuccess/AppointmentMovedSuccess'
import AppointmentMoveFailed from '../../MoveAppointment/components/AppointmentMoveFailed/AppointmentMoveFailed'
import { WorkshopOverview } from '../../Workshop/WorkshopOverview/WorkshopOverview'
import { BookWorkshop } from '../../Workshop/BookWorkshop/BookWorkshop'
import { CustomerStop } from '../../CustomerStop'
import { AppointmentConfirm } from '../../AppointmentConfirm/AppointmentConfirm'
import { AppointmentDate } from '../../AppointmentDate/AppointmentDate'
import { PaymentStatus as InvoicePaymentStatus } from '../../Invoice/PaymentStatus/PaymentStatus'
import { ErrorPage } from '../../ErrorPage/ErrorPage'
import { customerPortalLinks } from '../../App/Util/customerPortalUrl'
import { Spinner } from '../../App/Components'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { checkIfCustomerIsExisting } from '../../Settings/Store/Action'
import { useHistory } from '../../Router'

const RedirectToPortalProfile = () => {
  const { establishmentId } = useParams<{ establishmentId: string }>()
  useEffect(() => {
    Linking.openURL(customerPortalLinks.profile(establishmentId))
  }, [establishmentId])
  return null
}

const RedirectToPortalAppointments = () => {
  const { establishmentId } = useParams<{ establishmentId: string }>()
  useEffect(() => {
    Linking.openURL(customerPortalLinks.appointments(establishmentId))
  }, [establishmentId])
  return null
}

const AutOptIn = () => {
  const { establishmentId } = useParams<{ establishmentId: string }>()
  const history = useHistory()
  const dispatch = useAppDispatch()
  const session = getCustomerSession(establishmentId)
  const { customerUuid, unsubscribeToken } = useAppSelector(
    (state) => state.settings.user
  )

  useEffect(() => {
    if (!session) {
      const returnTo = window.location.href
      Linking.openURL(customerPortalLinks.login(establishmentId, returnTo))
      return
    }

    if (!customerUuid) {
      dispatch(checkIfCustomerIsExisting(establishmentId, session.email))
    }
  }, [session, customerUuid])

  useEffect(() => {
    if (customerUuid && unsubscribeToken) {
      history.replace(`/${establishmentId}/opt-in/${customerUuid}/${unsubscribeToken}`)
    }
  }, [customerUuid, unsubscribeToken])

  return <Spinner />
}

export const OnlineBookingOpen = () => (
  <Switch>
    <Route path="/:establishmentId/surveys" component={SurveyBootstrap} />
    {/* ---OPT IN PATH's--- */}

    <Route exact path="/:establishmentId/opt-in">
      <AutOptIn />
    </Route>

    <Route exact path="/:establishmentId/opt-in/:customerUuid/:customerToken"  component={OptInForm} />

    {/* ------------------- */}

    <Route exact path="/:establishmentId/error" component={ErrorPage} />

    <Route exact path="/:establishmentId" component={MainBootstrap} />
    <Route exact path="/:establishmentId/last-minutes">
      <CustomerStop component={LastMinutesOverview} />
    </Route>

    <Route exact path="/:establishmentId/last-minutes/:lastMinuteId">
      <CustomerStop component={BookLastMinute} />
    </Route>

    <Route exact path="/:establishmentId/last-minutes/:lastMinuteId/book">
      <CustomerStop component={BookLastMinute} />
    </Route>

    <Route exact path="/:establishmentId/workshops">
      <CustomerStop component={WorkshopOverview} />
    </Route>

    <Route exact path="/:establishmentId/workshops/:workshopUuid/book">
      <CustomerStop component={BookWorkshop} />
    </Route>

    <Route exact path="/:establishmentId/appointment/book">
      <CustomerStop component={BookAppointment} />
    </Route>

    <Route exact path="/:establishmentId/appointment/book/status">
      <CustomerStop component={BookingStatus} />
    </Route>

    <Route exact path="/:establishmentId/waiting-list/book">
      <CustomerStop component={BookWaitingList} />
    </Route>

    <Route exact path="/:establishmentId/waiting-list/book/status">
      <CustomerStop component={BookingStatus} />
    </Route>

    <Route exact path="/:establishmentId/select-location">
      <CustomerStop component={SelectLocation} />
    </Route>

    {/* ---ACCOUNT REDIRECTS (managed by Customer Portal)--- */}

    <Route path="/:establishmentId/previous-appointments">
      <RedirectToPortalAppointments />
    </Route>

    <Route path="/:establishmentId/account-info">
      <RedirectToPortalProfile />
    </Route>

    <Route path="/:establishmentId/account">
      <RedirectToPortalProfile />
    </Route>

    {/* ------------------- */}

    <Route
      exact
      path="/:establishmentId/appointment/:appointmentId/payment-status/:token/:email"
    >
      <CustomerStop component={PaymentFallback} />
    </Route>

    <Route exact path="/:establishmentId/appointment/date">
      <CustomerStop component={AppointmentDate} />
    </Route>

    <Route exact path="/:establishmentId/appointment/confirm">
      <CustomerStop component={AppointmentConfirm} />
    </Route>

    <Route exact path="/:establishmentId/appointment">
      <CustomerStop component={Appointment} />
    </Route>

    <Route
      exact
      path="/:establishmentId/appointment/move/:previousAppointmentId"
    >
      <CustomerStop component={MoveAppointment} />
    </Route>

    <Route
      exact
      path="/:establishmentId/appointment/moved/:previousAppointmentId"
    >
      <CustomerStop component={AppointmentMovedSuccess} />
    </Route>

    <Route exact path="/:establishmentId/appointment/move-failed">
      <CustomerStop component={AppointmentMoveFailed} />
    </Route>

    <Route exact path="/:establishmentId/select-person">
      <CustomerStop component={SelectPerson} />
    </Route>

    <Route exact path="/:establishmentId/select-person/:customerIndex">
      <CustomerStop component={SelectPerson} />
    </Route>

    <Route
      exact
      path="/:establishmentId/select-person/:customerIndex/:activityId"
    >
      <CustomerStop component={SelectPerson} />
    </Route>

    <Route exact path="/:establishmentId/edit-person">
      <CustomerStop component={EditPerson} />
    </Route>

    <Route exact path="/:establishmentId/edit-person/:activityId">
      <CustomerStop component={EditPerson} />
    </Route>

    <Route exact path="/:establishmentId/activities">
      <CustomerStop component={ExtraActivity} />
    </Route>

    <Route exact path="/:establishmentId/activities/:categoryId">
      <CustomerStop component={ExtraActivity} />
    </Route>

    <Route exact path="/:establishmentId/activities/:categoryId/:activityId">
      <CustomerStop component={ExtraActivity} />
    </Route>

    <Route exact path="/:establishmentId/annulation-condition">
      <CustomerStop component={AnnulationCondition} />
    </Route>

    <Route path="/:establishmentId/menu">
      <CustomerStop component={Menu} />
    </Route>

    <Route
      exact
      path="/:establishmentId/invoice/:invoiceId/payment-status/:token/:email"
      component={InvoicePaymentStatus}
    />

  </Switch>
)
